import { render, staticRenderFns } from "./ProductAverageCostSidebar.vue?vue&type=template&id=5e1f4531&scoped=true&"
import script from "./ProductAverageCostSidebar.vue?vue&type=script&lang=js&"
export * from "./ProductAverageCostSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1f4531",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e1f4531')) {
      api.createRecord('5e1f4531', component.options)
    } else {
      api.reload('5e1f4531', component.options)
    }
    module.hot.accept("./ProductAverageCostSidebar.vue?vue&type=template&id=5e1f4531&scoped=true&", function () {
      api.rerender('5e1f4531', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/product-average-cost/components/ProductAverageCostSidebar.vue"
export default component.exports